enum LtBicValue {
  REVOLT21 = 'REVOLT21',
  RETBLT21 = 'RETBLT21',
  REVOLT23 = 'REVOLT23',
}

export default LtBicValue;
